import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PaywallCheckoutPreview } from "@circle-react/types";

import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../";
import { CheckoutFormSection } from "../../../CheckoutFormSection";
import { DEFAULT_FULL_PREVIEW_VARIANT } from "../constants";

interface PaymentSchedulePreviewProps {
  className?: string;
  preview: PaywallCheckoutPreview;
  variant?: keyof typeof DEFAULT_FULL_PREVIEW_VARIANT;
}

export const PaymentSchedulePreview = ({
  className,
  preview,
  variant,
}: PaymentSchedulePreviewProps) => {
  if (
    variant === DEFAULT_FULL_PREVIEW_VARIANT.default ||
    !preview?.future_payments?.payment_schedule_line
  ) {
    return null;
  }

  return (
    <CheckoutFormSection className={classNames("gap-y-2 border-t", className)}>
      <DefaultFullPreview.PreviewEntry
        label={t("paywall_checkout.payment_schedule", {
          payment_sentence: preview.future_payments?.payment_schedule_line,
        })}
        labelSize="xs"
        labelWeight="medium"
        dataTestId="checkout-form-payment-schedule"
      />
    </CheckoutFormSection>
  );
};
